const japanPrefectures = {
  OVERSEA: '해외',
  HOKKAIDO: '홋카이도',
  AOMORI: '아오모리현',
  IWATE: '이와테현',
  MIYAGI: '미야기현',
  AKITA: '아키타현',
  YAMAGATA: '야마가타현',
  FUKUSHIMA: '후쿠시마현',
  IBARAKI: '이바라키현',
  TOCHIGI: '토치기현',
  GUNMA: '군마현',
  SAITAMA: '사이타마현',
  CHIBA: '지바현',
  TOKYO: '도쿄도',
  KANAGAWA: '가나가와현',
  NIIGATA: '니가타현',
  TOYAMA: '토야마현',
  ISHIKAWA: '이시카와현',
  FUKUI: '후쿠이현',
  YAMANASHI: '야마나시현',
  NAGANO: '나가노현',
  GIFU: '기후현',
  SHIZUOKA: '시즈오카현',
  AICHI: '아이치현',
  MIE: '미에현',
  SHIGA: '시가현',
  KYOTO: '교토부',
  OSAKA: '오사카부',
  HYOGO: '효고현',
  NARA: '나라현',
  WAKAYAMA: '와카야마현',
  TOTTORI: '돗토리현',
  SHIMANE: '시마네현',
  OKAYAMA: '오카야마현',
  HIROSHIMA: '히로시마현',
  YAMAGUCHI: '야마구치현',
  TOKUSHIMA: '도쿠시마현',
  KAGAWA: '가가와현',
  EHIME: '에히메현',
  KOCHI: '고치현',
  FUKUOKA: '후쿠오카현',
  SAGA: '사가현',
  NAGASAKI: '나가사키현',
  KUMAMOTO: '구마모토현',
  OITA: '오이타현',
  MIYAZAKI: '미야자키현',
  KAGOSHIMA: '가고시마현',
  OKINAWA: '오키나와현'
};

export default japanPrefectures;
